export default "__VITE_ASSET__99da46c6__"